export enum FINANCING_ORIGIN_ENUM {
  VALUE = 'value',
  QUOTATION = 'cotacao',
}

export type FinancingOriginValues = `${FINANCING_ORIGIN_ENUM}`
